import React from 'react';
import { AppBar, Box, Button, Grid } from '@mui/material';
import { BackIcon } from 'components/SVG';
import { SparkEditableTitle } from 'sharedComponents/UI';
import { SparkImageLoader } from 'sharedComponents/UI';
import { useSafeNavigate } from 'hooks/common';

type CreateSparkHeaderOnboardingProps = {
  value: string;
  setSparkName: (value: string) => void;
};

const CreateSparkHeaderOnboarding = React.forwardRef(
  function CreateSparkHeaderOnboarding(
    { value, setSparkName }: CreateSparkHeaderOnboardingProps,
    ref
  ) {
    const { handleRouteBack } = useSafeNavigate();
    return (
      <AppBar ref={ref as any}>
        <Grid
          container
          item
          position='fixed'
          bgcolor={(theme) => theme.palette.common.white}
          height='4rem'
          sx={{
            borderBottom: (theme) => `1px solid ${theme.palette.borderColor}`,
          }}
          wrap='nowrap'
        >
          <Grid
            container
            width={'81%'}
            gap={1}
            alignItems='center'
            marginLeft={1.5}
            wrap='nowrap'
          >
            <Box>
              <Button
                onClick={handleRouteBack}
                sx={{
                  minWidth: 'unset',
                  width: '45px',
                  height: '45px',
                  padding: 0,
                  borderWidth: '1px',
                  borderRadius: '14px',
                  borderColor: '#EEEEEE',
                  aspectRatio: 1,
                }}
                variant='outlined'
              >
                <BackIcon />
              </Button>
            </Box>
            <SparkEditableTitle
              value={value}
              onTitleSave={setSparkName}
              inputStyle={{ maxWidth: 'unset', paddingRight: 0 }}
              characterLengthOffSet={0}
            />
          </Grid>
          <Grid container alignItems='center'>
            <SparkImageLoader
              src='/SparkLogo.svg'
              alt='spark-logo'
              height={26.79}
              width={201}
            />
          </Grid>
        </Grid>
      </AppBar>
    );
  }
);

export default CreateSparkHeaderOnboarding;
